<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="center" align="center">
        <el-card shadow="never">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="account">
              <el-input v-model="form.account" class="login-form-input" minlength="2" maxlength="50" @keyup.enter.native="login">
                <img slot="prefix" :src="require('@/assets/images/mingcheng.png')" class="account-icon"/>
                <i slot="suffix" class="clear-box el-icon-close" @click="clearUserName" />
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" type="text" :class="['login-form-input', canSeePwd ? '' : 'password']" minlength="2" maxlength="50" @keyup.enter.native="login">
                <img slot="prefix" :src="require('@/assets/images/mima.png')" class="password-icon"/>
                <transition slot="suffix" enter-active-class="animated fade">
                  <i v-show="canSeePwd !== ''" class="clear-box" @click="seePassword">
                    <img :src="canSeePwd ? require('@/assets/images/yanjing.png') : require('@/assets/images/biyan.png')" class="password-see"/>
                  </i>
                </transition>
              </el-input>
            </el-form-item>
            <div class="btn-box">
              <el-button type="primary" @click="login">登录</el-button>
            </div>
            <div class="title-wrapper">
              <span class="welcome">WELCOME</span>
              <span class="title">{{title}}</span>
            </div>
          </el-form>
        </el-card>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import md5 from 'md5'

export default {
  name: 'Login',

  data () {
    return {
      title: this.$store.state.title,
      form: {
        account: '',
        password: '',
        platform: 1
      },
      rules: {
        account: [
          { required: true, message: '请填写用户账号', trigger: 'blur'}
        ],
        password: [
          { required: true, message: '请填写登录密码', trigger: 'blur'}
        ]
      },
      canSeePwd: false
    }
  },

  methods: {
    login () {
      this.$refs.form &&
      this.$refs.form.validate(validateResult => {
        const data = {
          account: this.form.account,
          password: md5(this.form.password)
        }
        validateResult && this.$store.dispatch('login', data).then(r => {
          if (r) {
            this.$router.push({
              name: 'home'
            })
          }
        }).catch((e) => {
          Promise.reject(e)
        })
      })
    },

    // 清除用户名
    clearUserName () {
      this.form.account = ''
    },

    // 查看密码
    seePassword () {
      const tmp = !this.canSeePwd
      this.canSeePwd = ''
      setTimeout(() => {
        this.canSeePwd = tmp
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-container {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 768px;
  min-width: 1024px;
  zoom: 1;
  background-size: cover;
  background: linear-gradient(#4796FC, #4784F5);
  background-repeat: no-repeat;
}

.el-main {
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}

.el-card {
  width: 80vw;
  height: 65vh;
  padding: 50px 60px;
  border: none;
  border-radius: 0;
  background: #fff url("~@/assets/images/login_bg.png") 10% 40% no-repeat;
  border-radius: 8px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  max-width: 1400px;
  max-height: 900px;
  min-height: 580px;
  min-width: 900px;

  /deep/ .el-card__body {
    display: flex;
    flex-direction: row-reverse;
  }

  .el-form {
    width: 300px;
    margin: 100px;
    position: relative;
  }
}

.btn-box {
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: center;
}

.el-button {
  width: 224px;
  height: 52px;
  font-size: 20px;
  font-family: 'MicrosoftYaHei'; 
  font-weight: 400;
  margin-top: 70px;
}

/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
  background-color: #fff !important;
}

.login-form-input.el-input {
  width: 280px;
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ .el-input__inner {
    flex: 1;
    height: 100%;
    background-color: rgb(255, 255, 255) !important;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #BABABA;
    padding-right: 53px;
    padding-left: 53px;

    &:focus {
      border-bottom: 1px solid #458EF4;
    }
  }

  /deep/ .el-input__prefix {
    width: 53px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    .account-icon {
      width: 22px;
      height: 23px;
    }

    .password-icon {
      width: 20px;
      height: 23px;
    }
  }

  /deep/ .el-input__suffix { 
    width: 40px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;

    .clear-box {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #797979;
      font-size: 18px;
      user-select: none;
    }

    .account-clear {
      width: 11px;
      height: 11px;
    }

    .password-see {
      width: 19px;
    }
  }
}

.password {
  /deep/ .el-input__inner {
    font-family: 'Password';
  }
}

.title-wrapper {
  position: absolute;
  top: -100px;
  width: 450px;
  left: 50%;
  transform: translate(-50%, 0);
  user-select: none;
  text-align: center;

  span {
    display: block;
  }

  .welcome {
    font-size: 49px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #3c6dcf;
    line-height: 65px;
    opacity: 0.2;
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .title {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: #3c6dcf;
    line-height: 24px;
  }
}
</style>
